module.exports = __webpack_public_path__ + "img/icon-contact.46df612e.svg";